import {
  faBeer,
  faBurger,
  faCocktail,
  faCookieBite,
  faChampagneGlasses,
  faCrown,
  faGlassWhiskey,
  faShoppingBag,
  faWineBottle,
  faUtensils,
  faBowlFood,
  faGlassWater,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

// Mapping nom-Lucide (côté back) -> icône FontAwesome (côté front).
// Les noms reflètent ceux utilisés dans la base.
const ICON_MAP = {
  Wine: faWineBottle,
  Beer: faBeer,
  Martini: faCocktail,
  Cocktail: faCocktail,
  GlassWater: faGlassWater,
  Glass: faGlassWater,
  Whiskey: faGlassWhiskey,
  Champagne: faChampagneGlasses,
  Crown: faCrown,
  Sandwich: faBurger,
  Burger: faBurger,
  Cookie: faCookieBite,
  Soup: faBowlFood,
  Bowl: faBowlFood,
  UtensilsCrossed: faUtensils,
  Utensils: faUtensils,
  ShoppingBag: faShoppingBag,
  Shop: faShoppingBag,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function renderCategoryIcon(
  iconName,
  color = "white",
  size = "4x",
  badge = null,
) {
  const icon = ICON_MAP[iconName] || faShoppingBag;
  const main = <FontAwesomeIcon icon={icon} size={size} color={color} />;
  if (!badge || !badge.icon) return main;
  const badgeIcon = ICON_MAP[badge.icon] || faCrown;
  return (
    <span
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon
        icon={badgeIcon}
        size="1x"
        color={badge.color || "gold"}
        style={{
          position: "absolute",
          top: "-8px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
        }}
      />
      {main}
    </span>
  );
}
